var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1C7.91775 1 6.37103 1.46919 5.05544 2.34824C3.73985 3.22729 2.71447 4.47672 2.10897 5.93853C1.50347 7.40034 1.34504 9.00887 1.65372 10.5607C1.9624 12.1126 2.72433 13.538 3.84315 14.6568C4.96197 15.7757 6.38743 16.5376 7.93928 16.8463C9.49113 17.155 11.0997 16.9965 12.5615 16.391C14.0233 15.7855 15.2727 14.7602 16.1518 13.4446C17.0308 12.129 17.5 10.5822 17.5 9",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 9.5,
    cy: 9,
    r: 8,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.36fd09b26101a84f43f99e200c3928c7.svg";
export { ForwardRef as ReactComponent };